import {
  type ComponentType,
  type FC,
  type PropsWithChildren,
  Suspense,
} from 'react'

import { ErrorBoundary } from '../../../error-boundary'

import { StoryblokErrorBoundaryFallback } from './StoryblokErrorBoundaryFallback'

export const withStoryblokSuspenseErrorBoundary = <P,>(
  Component: ComponentType<PropsWithChildren<P>>,
): FC<PropsWithChildren<P>> => {
  const WrappedWithErrorBoundary: FC<PropsWithChildren<P>> = (props) => (
    <Suspense fallback={null}>
      <ErrorBoundary fallback={<StoryblokErrorBoundaryFallback />}>
        <Component {...props} />
      </ErrorBoundary>
    </Suspense>
  )

  return WrappedWithErrorBoundary
}
